import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { UiSettingsSwitchComponent } from './switch.component';

@NgModule({
  declarations: [UiSettingsSwitchComponent],
  imports: [CommonModule, TranslateModule],
  exports: [UiSettingsSwitchComponent],
})
export class UiSettingsSwitchModule {}
